import React, { useState, useMemo, useEffect, use } from "react";
import Avatar from "components/BaseWidgets/Avatar";
import Button from "components/BaseWidgets/button";
import { getUser, retrieveToken } from "utils/storage";
import defaultProfilePic from "assets/images/png/dummy_avatar.png";
import { ref, onValue } from "firebase/database";
import { rtdb } from "../../../../../firebase/firebaseChat";

const ProfilePreview = ({
  selectedChatId,
  userChats,
  participants,
  selectedThread,
}) => {
  const currentUserId = getUser()?.aec_id;

  const selectedChat = userChats.find(
    (chat) => chat.id === selectedChatId || chat.chatId === selectedChatId
  );

  // ✅ Find opposite user (the one who isn’t currentUserId)
  const oppositeUserId = selectedChat?.users?.find(
    (id) => id !== currentUserId
  );
  const oppositeUser = selectedChat?.participants?.[oppositeUserId] || {};

  // ✅ Extract relevant data
  const {
    image: profilePic,
    name,
    accountId,
    lastSeen,
    isAccepted,
    status,
  } = oppositeUser;

  const isTyping = selectedChat?.typingStatus[oppositeUserId] || false;

  const [isOnline, setIsOnline] = useState(false);
  const [changed, setChanged] = useState(false);

  useEffect(() => {
    if (!selectedThread?.aec_id) return;

    const statusRef = ref(rtdb, `/status/${selectedThread?.aec_id}`);

    const unsubscribe = onValue(statusRef, (snapshot) => {
      const data = snapshot.val();
      // console.log("📡 RTDB presence:", selectedThread?.aec_id, data);
      setIsOnline(data?.online === true);
      setChanged(data?.lastChanged || null);
    });

    return () => unsubscribe();
  }, [selectedThread?.aec_id]);

  // console.log(participants, "participants");

  const lastSeenFormatted = new Date(changed).toLocaleString([], {
    hour: "2-digit",
    minute: "2-digit",
    month: "short",
    day: "numeric",
  });

  if (!selectedChatId) {
    return <div className="profile-preview">No chat selected</div>;
  }

  return (
    <div className="profile-preview">
      <Avatar
        url={
          selectedThread?.profile_image &&
          typeof selectedThread?.profile_image === "string"
            ? selectedThread?.profile_image
            : profilePic
        }
        size={64}
      />
      <div className="details">
        <h2 className="profile-name">
          {selectedThread?.aec_id || "Unknown User"}
        </h2>

        {isAccepted ? (
          <>
            <p className="acc-id">{selectedThread?.aec_id || "—"}</p>
            <span className="status">
              {isTyping
                ? "Typing..."
                : isOnline
                  ? "Online"
                  : lastSeenFormatted
                    ? `Last seen ${lastSeenFormatted}`
                    : "Offline"}
            </span>
          </>
        ) : (
          <div className="id-section">
            <p className="acc-id">{selectedThread?.aec_id || "—"}</p>
            {/* TODO: Last scene implementation */}
            <span className="time">
              {isTyping
                ? "Typing..."
                : isOnline
                  ? "Online"
                  : lastSeenFormatted
                    ? `Last seen ${lastSeenFormatted}`
                    : "Offline"}
            </span>{" "}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfilePreview;
